import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";
import tinymce, { Editor } from "tinymce";
import defaultTinymceConfig from "@/helpers/defaultTinymceConfig";
import debounce from "debounce";
import { TinymceSaveChangesError } from "@/types/tinymce-save-changes-error.type";


export default /*#__PURE__*/_defineComponent({
  __name: 'text-editor-component',
  props: {
    hideWatermark: { type: Boolean },
    pasteDisabled: { type: Boolean },
    onChange: null,
    onError: null,
    onChangeDebounceDuration: null,
    id: null
  },
  emits: {
  "on-editor-init": (editor: Editor) => editor,
},
  setup(__props: any, { emit }) {

const props = __props as {
  hideWatermark?: boolean;
  pasteDisabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange?: (content: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onError?: (error: TinymceSaveChangesError) => void;
  onChangeDebounceDuration?: number;
  id: string;
}





onMounted(() => {
  tinymce.init({
    selector: `textarea#${props.id}`,
    ...defaultTinymceConfig,
    content_css: false,
    statusbar: false,
    setup: (editor) => {
      //Since there's a class tox-toolbar--scrolling that causes responsiveness issues, we need to remove it
      editor.on("init", () => {
        emit("on-editor-init", editor);

        const toolbar = document.querySelector(".tox-toolbar");
        if (toolbar) {
          toolbar.classList.remove("tox-toolbar--scrolling");
        }
      });

      if (props.pasteDisabled) {
        editor.on("paste", function (e) {
          e.preventDefault();
          editor.notificationManager.open({
            text: "Pasting is disabled. Please type your answers.",
            type: "warning",
            timeout: 3000,
          });
        });
      }

      if (props.onChange) {
        editor.on(
          "change keyup",
          debounce(() => {
            try {
              const content = editor.getContent();
              props.onChange?.call(null, content);
            } catch (error) {
              if (props.onError) {
                props.onError("Error while getting content");
              }
            }
          }, props.onChangeDebounceDuration ?? 300)
        );
      }
    },
  });
});

return { __sfc: true,props, emit }
}

})